export const CRUD_PATH = `dayExpressInspection`

export const CRUD_PATH_PLURAL = `dayExpressInspections`
